import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c098fd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "firms" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "brush-map__title" }, "2. Выберите фирму ёршика", -1))
const _hoisted_3 = { class: "firms__buttons" }

import { ref, computed, onMounted, watch } from 'vue'
import { NameFirmType } from '@/shared/types'
import { BrushMapFirm } from '@/pages/BrushMapPage/brushMapFirm'
import { BrushMapController } from '@/pages/BrushMapPage/brushMapController'
import { useRoute } from 'vue-router'
import {
  TEPE,
  CURAPROX,
  CURASEPT,
  INTERPROX,
  FirmWithAutoFillColors,
} from '@/shared/constants/brushMapFirms'

interface Props {
  brushMapFirm: BrushMapFirm
  brushMapController: BrushMapController
}


export default /*#__PURE__*/_defineComponent({
  props: {
    brushMapFirm: null,
    brushMapController: null
  },
  emits: ['changeFirm', 'resetColors'],
  setup(__props: any, { emit }) {

const props = __props as {
  brushMapFirm: BrushMapFirm
  brushMapController: BrushMapController
}





const route = useRoute()

const reportId = computed(() => route.params.reportId)

const lastFirm = ref<FirmWithAutoFillColors>(CURAPROX)

function updateFirm(
  firm: FirmWithAutoFillColors,
  nameFirm: NameFirmType,
  firstGroup: string,
  secondGroup?: string
): void {
  if (firm.title === lastFirm.value.title) {
    return
  }

  props.brushMapController.updateFirm(
    lastFirm.value,
    firm.index,
    nameFirm,
    firstGroup,
    secondGroup
  )

  lastFirm.value = firm
}

function findCurrentFirm() {
  const currentFirmName = props.brushMapFirm.firm.nameFirm
  const variants = [CURAPROX, TEPE, INTERPROX, CURASEPT]
  const findedElement = variants.find(
    (variant) => variant.title === currentFirmName
  )
  lastFirm.value = findedElement
}

watch(
  () => props.brushMapFirm.firm.title,
  () => {
    findCurrentFirm()
  },
  { deep: true }
)

onMounted(() => {
  findCurrentFirm()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "firms__button--curaprox",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (updateFirm(_unref(CURAPROX), 'Curaprox', 'PRIME', 'PERIO')))
      }, " Curaprox "),
      _createElementVNode("button", {
        class: _normalizeClass([{
          firms__button_background: __props.brushMapFirm.firm.nameFirm === 'TePe',
        }, "firms__button"]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (updateFirm(_unref(TEPE), 'TePe', 'ЖЕСТКОСТЬ')))
      }, " TePe ", 2),
      _createElementVNode("button", {
        class: _normalizeClass([{
          firms__button_background: __props.brushMapFirm.firm.nameFirm === 'Interprox',
        }, "firms__button"]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (updateFirm(_unref(INTERPROX), 'Interprox', 'PLUS')))
      }, " Interprox ", 2),
      _createElementVNode("button", {
        class: _normalizeClass([{
          firms__button_background: __props.brushMapFirm.firm.nameFirm === 'Curasept',
        }, "firms__button"]),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (updateFirm(_unref(CURASEPT), 'Curasept', 'TREATMENT', 'PREVENTION')))
      }, " Curasept ", 2)
    ])
  ]))
}
}

})